/* LR Builder — full-screen product configurator (Liquid Rails)
   Shapes come from a collection, size tiers from the selected shape's
   variants, everything else rides on line item properties. */

(function () {
  'use strict';

  document.querySelectorAll('[data-lrb]').forEach(initBuilder);

  function initBuilder(root) {
    var cfgEl = root.querySelector('[data-lrb-config]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: cfg.currency || 'USD',
      });
    } catch (e) {
      fmt = { format: function (n) { return '$' + n.toFixed(2); } };
    }
    function money(cents) { return fmt.format(cents / 100); }

    var state = {
      shape: null,
      product: null,
      variant: null,
      tierVariants: [],
      nips: [],
      note: '',
      addonVariantId: null,
      addonLabel: null,
      addonPrice: 0,
      date: null, // Date object
      step: 0,
    };

    var overlay = root.querySelector('[data-lrb-overlay]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-lrb-step]'));
    var barBack = root.querySelector('[data-lrb-back]');
    var barNext = root.querySelector('[data-lrb-next]');
    var barTotal = root.querySelector('[data-lrb-total]');
    var barSummary = root.querySelector('[data-lrb-summary]');
    var dotsWrap = root.querySelector('[data-lrb-dots]');
    var errorEl = root.querySelector('[data-lrb-error]');
    var doneEl = root.querySelector('[data-lrb-done]');

    /* ── Hero: mouse parallax on the floating bottles ── */
    var heroEl = root.querySelector('[data-lrb-hero]');
    if (
      heroEl &&
      window.matchMedia('(hover: hover)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      var floats = heroEl.querySelectorAll('.lrb-float');
      if (floats.length) {
        var targetX = 0, targetY = 0, curX = 0, curY = 0, rafId = null;
        heroEl.addEventListener('mousemove', function (e) {
          var r = heroEl.getBoundingClientRect();
          targetX = (e.clientX - r.left) / r.width - 0.5;
          targetY = (e.clientY - r.top) / r.height - 0.5;
          if (rafId === null) rafId = requestAnimationFrame(parallaxTick);
        });
        var parallaxTick = function () {
          curX += (targetX - curX) * 0.08;
          curY += (targetY - curY) * 0.08;
          floats.forEach(function (f, i) {
            var depth = 34 + (i % 4) * 22; /* px of max drift, varied per bottle */
            var dir = i % 3 === 2 ? 1 : -1; /* every third bottle drifts WITH the cursor */
            f.style.setProperty('--px', (dir * curX * depth).toFixed(1) + 'px');
            f.style.setProperty('--py', (dir * curY * depth).toFixed(1) + 'px');
          });
          if (Math.abs(targetX - curX) + Math.abs(targetY - curY) > 0.002) {
            rafId = requestAnimationFrame(parallaxTick);
          } else {
            rafId = null;
          }
        };
      }
    }

    /* ── Overlay open/close ── */
    root.querySelectorAll('[data-lrb-start]').forEach(function (btn) {
      btn.addEventListener('click', function () { openOverlay(); });
    });
    function openOverlay() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      goTo(state.step || 0);
    }
    function closeOverlay() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    var closeBtn = root.querySelector('[data-lrb-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });

    /* ── Progress dots ── */
    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      steps.forEach(function (_, i) {
        if (stepName(i) === 'addon' && !showAddonStep()) return;
        var done = i < state.step;
        var d = document.createElement(done ? 'button' : 'span');
        d.className = 'lrb-dots__dot' + (i === state.step ? ' is-current' : done ? ' is-done' : '');
        if (done) {
          d.type = 'button';
          d.setAttribute('aria-label', cfg.msg.backToStep.replace('[n]', i + 1));
          d.addEventListener('click', function () { goTo(i); });
        }
        dotsWrap.appendChild(d);
      });
    }

    /* ── Step navigation ── */
    function stepName(i) { return steps[i] ? steps[i].dataset.lrbStep : null; }

    /* The upsell step only shows when the customer maxed out the shape's
       own size tiers (configurable via the "addonMaxOnly" setting). */
    function isMaxTier() {
      return !!(
        state.variant &&
        state.tierVariants.length &&
        state.variant.id === state.tierVariants[state.tierVariants.length - 1].id
      );
    }
    function showAddonStep() {
      return !cfg.addonMaxOnly || isMaxTier();
    }
    function clearAddon() {
      state.addonVariantId = null;
      state.addonLabel = null;
      state.addonPrice = 0;
      root.querySelectorAll('[data-lrb-addon-option]').forEach(function (c) {
        var decline = c.dataset.variantId === '';
        c.classList.toggle('is-selected', decline);
        c.setAttribute('aria-pressed', decline ? 'true' : 'false');
      });
    }

    function goTo(i) {
      if (i < 0 || i >= steps.length) return;
      while (stepName(i) === 'addon' && !showAddonStep()) {
        i += i >= state.step ? 1 : -1;
        if (i < 0 || i >= steps.length) return;
      }
      state.step = i;
      steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      if (doneEl) doneEl.classList.remove('is-active');
      renderDots();
      updateBar();
      setError('');
      var body = root.querySelector('[data-lrb-body]');
      if (body) body.scrollTop = 0;
      if (stepName(i) === 'tier') positionLlama();
    }

    function validateStep() {
      switch (stepName(state.step)) {
        case 'shape':
          if (!state.shape) return cfg.msg.pickShape;
          break;
        case 'tier':
          if (!state.variant) return cfg.msg.pickTier;
          break;
        case 'nips':
          if (!state.nips.length) return cfg.msg.pickNips;
          break;
        case 'date':
          if (cfg.dateRequired && !state.date) return cfg.msg.pickDate;
          break;
      }
      return null;
    }

    function setError(msg) { if (errorEl) errorEl.textContent = msg || ''; }

    function updateBar() {
      var isLast = state.step === steps.length - 1;
      barNext.textContent = isLast ? cfg.msg.addToCart : cfg.msg.continueLabel;
      barBack.hidden = state.step === 0;
      var total = 0;
      if (state.variant) total += state.variant.price;
      if (state.addonVariantId) total += state.addonPrice;
      barTotal.textContent = total ? money(total) : '';
      var bits = [];
      if (state.shape) bits.push(state.shape.title);
      if (state.variant && state.variant.title !== 'Default Title') bits.push(state.variant.title);
      if (state.nips.length) bits.push(state.nips.length + ' ' + cfg.msg.contentsLabel.toLowerCase());
      barSummary.textContent = bits.join(' · ');
    }

    barBack.addEventListener('click', function () { goTo(state.step - 1); });
    barNext.addEventListener('click', function () {
      var err = validateStep();
      if (err) { setError(err); return; }
      if (state.step === steps.length - 1) { addToCart(); return; }
      goTo(state.step + 1);
    });

    /* ── Step 1: shapes ── */
    var shapesWrap = root.querySelector('[data-lrb-shapes]');
    if (shapesWrap) {
      var track = shapesWrap.querySelector('.lrb-shapes__track');
      shapesWrap.querySelectorAll('.lrb-shapes__arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({ left: btn.dataset.dir === 'next' ? 320 : -320, behavior: 'smooth' });
        });
      });
      shapesWrap.querySelectorAll('.lrb-shape').forEach(function (card) {
        card.addEventListener('click', function () {
          shapesWrap.classList.add('has-selection');
          shapesWrap.querySelectorAll('.lrb-shape').forEach(function (c) {
            c.classList.remove('is-selected');
            c.setAttribute('aria-pressed', 'false');
          });
          card.classList.add('is-selected');
          card.setAttribute('aria-pressed', 'true');
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          selectShape(card.dataset.handle, card.dataset.title);
        });
      });
    }

    function selectShape(handle, title) {
      state.shape = { handle: handle, title: title };
      state.product = null;
      state.variant = null;
      updateBar();
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          state.product = p;
          var avail = p.variants.filter(function (v) { return v.available; });
          if (!avail.length) {
            state.variant = null;
            state.tierVariants = [];
            clearAddon();
            if (tiersWrap) {
              tiersWrap.innerHTML = '';
              var msg = document.createElement('p');
              msg.className = 'lrb-tiers--single';
              msg.textContent = cfg.msg.soldOut;
              tiersWrap.appendChild(msg);
            }
            setError(cfg.msg.soldOut);
            updateBar();
            return;
          }
          renderTiers(avail);
        })
        .catch(function () { setError(cfg.msg.genericError); });
    }

    /* ── Step 2: tiers with llama slider ── */
    var tiersWrap = root.querySelector('[data-lrb-tiers]');
    var llamaImg = null;
    var slider = null;

    function positionLlama() {
      if (!slider) return;
      var wrap = slider.parentElement;
      var max = parseInt(slider.max, 10) || 1;
      var ratio = max ? parseInt(slider.value, 10) / max : 0;
      /* pink up to the llama, grey after it */
      var accent = getComputedStyle(root).getPropertyValue('--lrb-accent').trim() || '#ff2e93';
      var pct = (ratio * 100) + '%';
      slider.style.background =
        'linear-gradient(to right, ' + accent + ' 0%, ' + accent + ' ' + pct + ', #e4e4e4 ' + pct + ', #e4e4e4 100%)';
      if (llamaImg) {
        var w = wrap.clientWidth - 20; /* wrap padding 0 1rem */
        llamaImg.style.left = (10 + ratio * w) + 'px';
      }
    }
    window.addEventListener('resize', positionLlama);

    function renderTiers(variants) {
      if (!tiersWrap) return;
      tiersWrap.innerHTML = '';
      llamaImg = null;
      slider = null;
      state.tierVariants = variants;
      if (variants.length === 1) {
        state.variant = variants[0];
        var single = document.createElement('p');
        single.className = 'lrb-tiers--single';
        single.textContent = (variants[0].title === 'Default Title' ? state.shape.title : variants[0].title) +
          ' — ' + money(variants[0].price);
        tiersWrap.appendChild(single);
        updateBar();
        updateDistribution();
        return;
      }

      var labels = document.createElement('div');
      labels.className = 'lrb-tiers__labels';
      variants.forEach(function (v, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lrb-tiers__label';
        b.textContent = v.title + ' ' + money(v.price);
        b.addEventListener('click', function () { slider.value = i; onSlide(); });
        labels.appendChild(b);
      });
      tiersWrap.appendChild(labels);

      var wrap = document.createElement('div');
      wrap.className = 'lrb-tiers__slider-wrap';
      slider = document.createElement('input');
      slider.type = 'range';
      slider.className = 'lrb-tiers__slider';
      slider.min = 0;
      slider.max = variants.length - 1;
      slider.step = 1;
      slider.value = 0;
      slider.setAttribute('aria-label', cfg.msg.tierAria);
      wrap.appendChild(slider);
      if (cfg.llamaSrc) {
        llamaImg = document.createElement('img');
        llamaImg.src = cfg.llamaSrc;
        llamaImg.alt = '';
        llamaImg.className = 'lrb-tiers__llama';
        wrap.appendChild(llamaImg);
      }
      tiersWrap.appendChild(wrap);

      var quips = null;
      if (cfg.tiers && cfg.tiers.length && variants.length === 3) {
        quips = document.createElement('div');
        quips.className = 'lrb-tiers__quips';
        variants.forEach(function (_, i) {
          var t = cfg.tiers[i] || {};
          var q = document.createElement('div');
          q.className = 'lrb-tiers__quip';
          q.innerHTML = '<span class="lrb-tiers__quip-name"></span><span class="lrb-tiers__quip-text"></span>';
          q.querySelector('.lrb-tiers__quip-name').textContent = t.name || '';
          q.querySelector('.lrb-tiers__quip-text').textContent = t.quip || '';
          quips.appendChild(q);
        });
        tiersWrap.appendChild(quips);
      }

      function onSlide() {
        var i = parseInt(slider.value, 10);
        state.variant = variants[i];
        if (!isMaxTier()) clearAddon();
        labels.querySelectorAll('.lrb-tiers__label').forEach(function (l, j) {
          l.classList.toggle('is-selected', j === i);
        });
        if (quips) {
          quips.querySelectorAll('.lrb-tiers__quip').forEach(function (q, j) {
            q.classList.toggle('is-selected', j === i);
          });
        }
        positionLlama();
        updateBar();
        updateDistribution();
      }
      slider.addEventListener('input', onSlide);
      onSlide();
    }

    /* ── Step 3: contents ── */
    root.querySelectorAll('[data-lrb-nip]').forEach(function (card) {
      card.addEventListener('click', function () {
        var title = card.dataset.title;
        var idx = state.nips.indexOf(title);
        if (idx === -1) state.nips.push(title);
        else state.nips.splice(idx, 1);
        card.classList.toggle('is-selected', idx === -1);
        card.setAttribute('aria-pressed', idx === -1 ? 'true' : 'false');
        updateBar();
        updateDistribution();
        setError('');
      });
    });

    var distEl = root.querySelector('[data-lrb-distribution]');
    function updateDistribution() {
      if (!distEl) return;
      var total = totalNipCount();
      if (!total || !state.nips.length) { distEl.textContent = ''; return; }
      var per = Math.floor(total / state.nips.length);
      distEl.textContent = cfg.msg.distribution
        .replace('[total]', total)
        .replace('[per]', per)
        .replace('[count]', state.nips.length);
    }

    function totalNipCount() {
      var n = 0;
      if (state.variant) {
        var m = /\d+/.exec(state.variant.title);
        if (m) n = parseInt(m[0], 10);
      }
      if (state.addonLabel) {
        var a = /\d+/.exec(state.addonLabel);
        if (a) n += parseInt(a[0], 10);
      }
      return n;
    }

    /* ── Step 4: note ── */
    var noteInput = root.querySelector('[data-lrb-note]');
    var noteCount = root.querySelector('[data-lrb-note-count]');
    if (noteInput) {
      noteInput.addEventListener('input', function () {
        state.note = noteInput.value;
        if (noteCount) noteCount.textContent = noteInput.value.length + '/' + noteInput.maxLength;
      });
    }

    /* ── Step 5: addon upsell ── */
    root.querySelectorAll('[data-lrb-addon-option]').forEach(function (card) {
      card.addEventListener('click', function () {
        root.querySelectorAll('[data-lrb-addon-option]').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
        var id = card.dataset.variantId;
        state.addonVariantId = id ? parseInt(id, 10) : null;
        state.addonLabel = id ? card.dataset.title : null;
        state.addonPrice = id ? parseInt(card.dataset.price, 10) : 0;
        updateBar();
        updateDistribution();
      });
    });

    /* ── Step 6: calendar ── */
    var calEl = root.querySelector('[data-lrb-cal]');
    if (calEl) buildCalendar(calEl);

    function buildCalendar(el) {
      var min = new Date();
      min.setHours(0, 0, 0, 0);
      min.setDate(min.getDate() + (cfg.leadDays || 0));
      var view = new Date(min.getFullYear(), min.getMonth(), 1);
      var months = cfg.cal.months;
      var dows = cfg.cal.dows;

      var sideMonth = el.querySelector('[data-cal-side-month]');
      var sideDay = el.querySelector('[data-cal-side-day]');
      var sideWeekday = el.querySelector('[data-cal-side-weekday]');
      var navLabel = el.querySelector('[data-cal-nav-label]');
      var grid = el.querySelector('[data-cal-grid]');
      var prev = el.querySelector('[data-cal-prev]');
      var next = el.querySelector('[data-cal-next]');

      prev.addEventListener('click', function () {
        view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
        render();
      });
      next.addEventListener('click', function () {
        view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
        render();
      });

      function sameDay(a, b) {
        return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
      }

      function render() {
        navLabel.textContent = months[view.getMonth()] + ' ' + view.getFullYear();
        prev.disabled = view.getFullYear() === min.getFullYear() && view.getMonth() === min.getMonth();
        grid.innerHTML = '';
        dows.forEach(function (d) {
          var s = document.createElement('span');
          s.className = 'lrb-cal__dow';
          s.textContent = d;
          grid.appendChild(s);
        });
        var firstDow = new Date(view.getFullYear(), view.getMonth(), 1).getDay();
        var daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
        for (var i = 0; i < firstDow; i++) grid.appendChild(document.createElement('span'));
        for (var d = 1; d <= daysInMonth; d++) {
          (function (d) {
            var day = new Date(view.getFullYear(), view.getMonth(), d);
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'lrb-cal__day' + (sameDay(day, state.date) ? ' is-selected' : '');
            b.textContent = d;
            b.disabled = day < min;
            b.addEventListener('click', function () {
              state.date = day;
              setError('');
              render();
              updateSide();
            });
            grid.appendChild(b);
          })(d);
        }
      }

      function updateSide() {
        var d = state.date || min;
        sideMonth.textContent = months[d.getMonth()];
        sideDay.textContent = ('0' + d.getDate()).slice(-2);
        sideWeekday.textContent = cfg.cal.days[d.getDay()];
      }

      render();
      updateSide();
    }

    function isoDate(d) {
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    }

    /* ── Add to cart ── */
    function addToCart() {
      barNext.disabled = true;
      var props = {};
      props[cfg.msg.contentsLabel] = state.nips.join(', ');
      if (state.note.trim()) props[cfg.msg.noteLabel] = state.note.trim();
      if (state.date) props[cfg.msg.dateLabel] = isoDate(state.date);
      if (state.addonLabel) props[cfg.msg.addonLabel] = state.addonLabel;

      var items = [{ id: state.variant.id, quantity: 1, properties: props }];
      if (state.addonVariantId) {
        var addonProps = {};
        addonProps[cfg.msg.forLabel] = state.shape.title;
        items.push({ id: state.addonVariantId, quantity: 1, properties: addonProps });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message); });
          return r.json();
        })
        .then(function () {
          refreshCartUI();
          showDone();
        })
        .catch(function (e) {
          setError(e.message || cfg.msg.genericError);
        })
        .finally(function () { barNext.disabled = false; });
    }

    function showDone() {
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      if (doneEl) doneEl.classList.add('is-active');
      if (dotsWrap) dotsWrap.hidden = true;
      var bar = root.querySelector('[data-lrb-bar]');
      if (bar) bar.hidden = true;
    }

    var restart = root.querySelector('[data-lrb-restart]');
    if (restart) restart.addEventListener('click', function () { window.location.reload(); });
    var viewCart = root.querySelector('[data-lrb-viewcart]');
    if (viewCart) {
      viewCart.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          closeOverlay();
          drawer.open();
        }
        /* otherwise it's a normal link to /cart */
      });
    }

    /* Cart drawer + icon refresh (same pattern as lr-bundle-builder) */
    function refreshCartUI() {
      fetch('/?section_id=cart-icon-bubble')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var target = document.getElementById('cart-icon-bubble');
          if (!target) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('.shopify-section');
          if (source) target.innerHTML = source.innerHTML;
        })
        .catch(function () {});

      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(cartUrl + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('#CartDrawer');
          var target = document.getElementById('CartDrawer');
          if (source && target) {
            target.innerHTML = source.innerHTML;
            var overlayEl = target.querySelector('#CartDrawer-Overlay');
            if (overlayEl) overlayEl.addEventListener('click', function () { cartDrawer.close(); });
          }
          cartDrawer.classList.remove('is-empty');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lr-builder' });
          }
        })
        .catch(function () {});
    }

    renderDots();
    updateBar();
  }
})();
